import { render } from "./CnAbout.vue?vue&type=template&id=22eefd23&scoped=true"
const script = {}

import "./CnAbout.vue?vue&type=style&index=0&id=22eefd23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22eefd23"

export default script